import { UPLOAD_INVENTORY_FILE_MODAL_TYPES } from '../../../../constants/uploadInventoryFileModalTypes';

export const uploadInventoryFileToastMessages = {
  [UPLOAD_INVENTORY_FILE_MODAL_TYPES.quantity]: {
    success:
      'We have received your inventory amounts and will send you an email when they are processed in our system.',
    error: "Unable to update your product's inventory. Please try again. ",
  },
  [UPLOAD_INVENTORY_FILE_MODAL_TYPES.buffers]: {
    success: 'We have received your buffer updates and will send you an email when they are processed in our system.  ',
    error: 'Unable to upload the buffers. Please try again. ',
  },
};
